export const scheduleSaveButton = "Sxc";
export default {scheduleSaveButton};